import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { HeaderModule } from '@coreui/angular';
import { navItems } from './_nav';
import { JWTTokenService } from '../../services/jwt-token.service';
import { Router, RouterModule } from '@angular/router';
import { DropdownModule, SidebarModule } from '@coreui/angular';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { DefaultHeaderComponent } from './default-header/default-header.component';
import { DefaultFooterComponent } from './default-footer/default-footer.component';
import { ContainerComponent } from '@coreui/angular';
import { AuthStateService } from '../../services/auth-state.service';

@Component({
  standalone: true,
  imports: [
    RouterModule,
    SidebarModule,
    DropdownModule,
    NgScrollbarModule,
    DefaultHeaderComponent,
    DefaultFooterComponent,
    HeaderModule,
    ContainerComponent,
  ],
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultLayoutComponent implements OnInit {
  public navItems = navItems;

  constructor(
    private readonly jwtTokenService: JWTTokenService,
    private readonly router: Router,
    private readonly authState: AuthStateService,
  ) {}

  /**
   * Verify if user is authenticated via httpOnly cookie
   * @returns boolean
   */
  private isConnected(): boolean {
    // Use AuthStateService instead of direct localStorage access
    const isAuthenticated = this.authState.isAuthenticated();

    if (!isAuthenticated) {
      this.jwtTokenService.clear();
      this.authState.clearAuthState();
      this.router.navigateByUrl('/login');

      return false;
    }

    return true;
  }

  ngOnInit(): void {
    this.isConnected();
  }
}
